module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_fresh_green-e7f3d9c2a2d31ed5c56485a23dacd1ff.jpg";